<template>
      <v-text-field
        v-model="email"
        :label="label"
        :error="error"
        :error-messages="message"
        v-on:blur='handleBlur'
      >
      </v-text-field>
</template>

<script>
import * as EmailValidator from "email-validator";

export default {
  props: ["value", "label"],
  data() {
    return {
      email: "",
      valid: false,
      error: false,
      message: ""
    };
  },
  methods: {
    handleBlur() {
      if (this.email !== undefined && this.email != "") {
        try {
          this.valid = EmailValidator.validate(this.email);
          if (!this.valid) {
            this.error = true;
            this.message = "Email is niet geldig";
          } else {
            this.error = false;
            this.message = "";
          }
        } catch (error) {
          this.error = true;
          this.message = "Email is niet geldig";
        }
      } else {
        this.error = false;
        this.message = "";
      }
    }
  },
  created() {
    this.email = this.value;
  },
  watch: {
    value() {
      this.email = this.value;
    },
    email() {
      this.$emit("input", this.email);
    },
    error() {
      if (this.error) {
        this.$store.state.app.form.disabled = true;
      } else if (!this.error) {
        this.$store.state.app.form.disabled = false;
      }
    }
  }
};
</script>
